import type { z } from "zod";

import instance from "..";
import { looseParse } from "../looseParse";
import {
  accountAccessResponseSchema,
  type accountAccessRoleAssignmentSchema,
  type accountAccessRoleSchema,
  accountAccessRolesResponseSchema,
} from "./accountAccess.schema";

export type AccountAccessRole = z.infer<typeof accountAccessRoleSchema>;

export type AccountAccessResponse = z.infer<typeof accountAccessResponseSchema>;

export type AccountAccessRoleAssignment = z.infer<
  typeof accountAccessRoleAssignmentSchema
>;

export interface ListAccountAccessRolesParams {
  limit?: number;
  cursor?: string;
}

export type AccountAccessRolesResponse = z.infer<
  typeof accountAccessRolesResponseSchema
>;

export const getMyAccountAccess = async (
  accountID: string,
): Promise<AccountAccessResponse> => {
  const res = await instance.get<AccountAccessResponse>(
    `/accounts/${accountID}/access/me`,
    { baseURL: window.env.TRADING_API_BASE_URL },
  );
  return looseParse(
    accountAccessResponseSchema,
    res.data,
    "getMyAccountAccess",
  );
};

export const listAccountAccessRoles = async (
  accountID: string,
  params: ListAccountAccessRolesParams = {},
): Promise<AccountAccessRolesResponse> => {
  const res = await instance.get<AccountAccessRolesResponse>(
    `/accounts/${accountID}/access/roles`,
    { baseURL: window.env.TRADING_API_BASE_URL, params },
  );
  return looseParse(
    accountAccessRolesResponseSchema,
    res.data,
    "listAccountAccessRoles",
  );
};
